import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { uiActions } from "../store/ui/ui-slice";
import useRoutePermission from "../Hooks/useRoutePermission";
import { useTokenGuard } from "../Hooks";
import { dispatch } from "../store";

const ProtectedRoute = ({ children }) => {
  const { token, user } = useSelector((state) => state.user);
  const { isAllowed } = useRoutePermission({ user });

  useTokenGuard({ token, dispatch });

  useEffect(() => {
    dispatch(uiActions.clearCanvasOption());
    dispatch(uiActions.clearModalOption());
    dispatch(uiActions.setLoading(false));
    dispatch(uiActions.setFormSubmitLoading(false));
  }, [dispatch]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
